var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SearchResultsCard',{key:_vm.searchTerm,attrs:{"searchTerm":_vm.searchTerm}})}
var staticRenderFns = []

export { render, staticRenderFns }